import Vue from "vue";
import Vuetify from "vuetify/lib";
import { vuetifyTheme } from "@/config.js";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: vuetifyTheme
    }
  }
});
